import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import moment from "moment";

interface ShiftAtomCheckListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;
    meta: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
    ingredients: any[];
}

const state: ShiftAtomCheckListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: [],
    ingredients: [],
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_VDP = 'GET_SHIFT_FACT_VDP';
const GET_SCHEMA_FACT_VDP = 'GET_SCHEMA_FACT_VDP';


export const actions: ActionTree<ShiftAtomCheckListState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(GET_SHIFT_FACT_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sja.id',
                  plan_id: 'sja.plan_id',
                  number: 'sa.number',
                  product_name: 'pp.name',
                  quantity: 'sfa.quantity',
                  container_name: 'vcnt.name',
                  comments: 'sja.comments',
                  check_1: 'sja.check_1',
                  value_1: 'sja.value_1',
                  check_2: 'sja.check_2',
                  value_2: 'sja.value_2',
                  check_3: 'sja.check_3',
                  value_3: 'sja.value_3',
                  check_4: 'sja.check_4',
                  value_4: 'sja.value_4',
                  check_5: 'sja.check_5',
                  value_5: 'sja.value_5',
                  check_6: 'sja.check_6',
                  value_6: 'sja.value_6',
                  check_7: 'sja.check_7',
                  value_7: 'sja.value_7',
                  check_8: 'sja.check_8',
                  value_8: 'sja.value_8',
                  check_9: 'sja.check_9',
                  value_9: 'sja.value_9',
                  check_10: 'sja.check_10',
                  value_10: 'sja.value_10',
                  check_11: 'sja.check_11',
                  value_11: 'sja.value_11',
                  disposal_quantity: 'sja.disposal_quantity',
                },
                from: 's:shift_atom_check_lists',
                from_as: 'sja',
                joins: [
                  {
                    join: 's:shift_atom',
                    type: 'left',
                    as:   'sa',
                    on: {
                      $eq: ['sja.plan_id', 'sa.id']
                    }
                  },
                  {
                    join: 's:products',
                    type: 'left',
                    as:   'pp',
                    on: {
                      $eq: ['sa.product_id', 'pp.id']
                    }
                  },
                  {
                    join: 's:shift_fact_atom',
                    type: 'left',
                    as:   'sfa',
                    on: {
                      $eq: ['sja.plan_id', 'sfa.plan_id']
                    }
                  },
                  {
                    join: 's:voc_containers',
                    type: 'left',
                    as:   'vcnt',
                    on: {
                      $eq: ['sfa.container_id', 'vcnt.id']
                    }
                  },
                ],
                order: [
                  {$desc: ['sa.number']},
                  {$desc: ['sa.id']},
                ],
                groups: [
                  "sja.id",
                  'sa.id',
                  'pp.name',
                  'sfa.quantity',
                  'vcnt.name',
                  // 'vd.name',
                  // 'vc.name',
                  // 'sacpi.quantity',
                  // 'vcnt.weight'
                ],
                where: {
                  $and: [
                    {$eq: [`sa.shift_id`, {$: documentId}]},
                  ]
                }
              }),
              vm.$q(GET_SCHEMA_FACT_VDP)
              .raw('schemas.get')
              .action({
                  id: `s:shift_journal_vdp`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_VDP);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.sum_values = Object.keys(item).reduce((acc: number, key: string) => {
                  if (key.includes('value_')) {
                    acc += item[key]
                  }
                  return acc
                }, 0)
                return item
              })
            }
            const opRelSchema = result.getOperation(GET_SCHEMA_FACT_VDP);
            if (!opRelSchema.hasError()) {
              state.meta = fetchEnumsFromSchema(opRelSchema.getContent().schema)
            }

            commit('LOADED_SUCCESS');
            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Вода, л</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Температура воды, градусы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Температура заквашивания, градусы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Нагрев до</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Выдержка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время гомогенизации</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Давление</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Количество ведер</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Чистый вес</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время заквашивания</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала гомогенизации</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>pH смеси</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>pH после созревания полупродукта</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Рекомендуемое время выемки</td>
</tr>
{{#facts.documents}}
  <tr height="auto">
    <td wrap border base >{{base_name}}</td>
    <td wrap border base type=number round align=center>{{water}}</td>
    <td wrap border base align=center>{{water_temp}}</td>
    <td wrap border base round align=center>{{ferment_temp}}</td>
    <td wrap border base round align=center>{{heat_to}}</td>
    <td wrap border base round align=center>{{delay}}</td>
    <td wrap border base type="time" round align=center>{{homogen_time}}</td>
    <td wrap border base round align=center>{{pressure}}</td>
    <td wrap border base type=number align=center>{{quantity}}</td>
    <td wrap border base type=number align=center>{{weight}}</td>
    <td wrap border base type="date" align=center>{{start_time}}</td>
    <td wrap border base type="date" align=center>{{ferment_time}}</td>
    <td wrap border base type="date" align=center>{{homoget_time}}</td>
    <td wrap border base align=center>{{acidity}}</td>
    <td wrap border base align=center>{{acidity_fact}}</td>
    <td wrap border base type="date" align=center>{{recomended_ferment_time}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                      id: 'sjv.id',
                      plan_id: 'sjv.plan_id',
                      product_name: 'pp.name',
                    },
                    from: 's:shift_journal_atom',
                    from_as: 'sja',
                    joins: [
                      {
                        join: 's:shift_atom_coock_plan',
                        type: 'left',
                        as:   'sacp',
                        on: {
                          $eq: ['sja.plan_id', 'sacp.id']
                        }
                      },
                      {
                        join: 's:produced_products',
                        type: 'left',
                        as:   'pp',
                        on: {
                          $eq: ['sacp.product_id', 'pp.id']
                        }
                      },
                      {
                        join: 's:voc_release_gps',
                        type: 'left',
                        as:   'vrg',
                        on: {
                          $eq: ['sja.release_id', 'vrg.id']
                        }
                      },
                      {
                        join: 's:voc_quality_pps',
                        type: 'left',
                        as:   'vqp',
                        on: {
                          $eq: ['sja.quality_id', 'vqp.id']
                        }
                      },
                      {
                        join: 's:voc_densities',
                        type: 'left',
                        as:   'vd',
                        on: {
                          $eq: ['sja.density_id', 'vd.id']
                        }
                      },
                      {
                        join: 's:voc_consistencies',
                        type: 'left',
                        as:   'vc',
                        on: {
                          $eq: ['sja.consistency_id', 'vc.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sjv.id']}
                    ],
                    where: {
                      $eq: [`spv.shift_id`, {$: documentId}]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    }
};

export const mutations: MutationTree<ShiftAtomCheckListState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftAtomCheckListState, RootState> = {
  totals : (state: ShiftAtomCheckListState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  rotateJournal: (state: ShiftAtomCheckListState) => {
    const journal = state.relatedFactsList.reduce((prev: any, item: any, idx: number) => {
      Object.keys(item).map((key: any) => {
        if (!prev[key]){
          prev[key] = [];
        }
        prev[key].push(item[key]);
      })
      if (!prev.positions[item.number]) {
        prev.positions[item.number] = item.id
      }
      prev.rows.push(item)
      return prev
    }, {rows: [], total_weight: [], positions: []})

    return journal;
  }
};

export const STORE_KEY = '$_shift_atom_check_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
